import { render } from "./MainMenu.vue?vue&type=template&id=fb328fd8"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/MainMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb328fd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb328fd8', __exports__)) {
    console.log('reload')
    api.reload('fb328fd8', __exports__)
  }
  
  module.hot.accept("./MainMenu.vue?vue&type=template&id=fb328fd8", () => {
    console.log('re-render')
    api.rerender('fb328fd8', render)
  })

}


export default __exports__